/**
 * Interface que define a estrutura de um marcador no mapa
 * Centraliza a tipagem para facilitar manutenção e reutilização
 */
export interface IMarkerData {
  position: { lat: number; lng: number }; // Coordenadas lat/lng do marcador
  title?: string;                      // Título do marcador (opcional)
  address?: string;                    // Endereço do marcador (opcional)
  id?: string | number;               // ID único do marcador (opcional)
}
